/**
 * arbi-docs Supabase client. Uses the SAME storage adapter as arbi root +
 * arbi-dev so the auth cookie scoped to .ironcladsupply.co is shared across
 * arbi / arbi-dev / arbi-docs. ADR 38.
 *
 * The adapter source of truth is `src/lib/supabaseStorage.ts` at repo root —
 * relative-imported here per ADR 36 (sibling-apps pattern). This client serves
 * the arbi-docs page reads (docs_pages / release_notes); the shared AppContext
 * (re-exported from root) carries its own root client for auth/profile — both
 * read the same cookie session.
 */
import { createClient } from '@supabase/supabase-js';
import type { Database } from '../../../../src/lib/database.types';
import { createSupabaseStorage } from '../../../../src/lib/supabaseStorage';

const supabaseUrl: string | undefined = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey: string | undefined = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    '[arbi-docs] Supabase credentials not set. ' +
      'Vercel project arbi-isg-docs needs VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY ' +
      'configured under Settings → Environment Variables.'
  );
}

export const supabase = createClient<Database>(
  supabaseUrl ?? 'https://placeholder.supabase.co',
  supabaseAnonKey ?? 'placeholder',
  {
    auth: {
      storage: createSupabaseStorage(),
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);

if (import.meta.env.DEV) (window as unknown as { supabase: typeof supabase }).supabase = supabase;
